import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Banner extends Component {
  
  render() {
    return(
      <div className="banner">
        <h1>
          Save your go-to apps<br/>from around the web<br/>
          <Link className="btn" to="/signup" >Sign Up</Link>
          <Link className="btn alt" to="/signin" >Sign In</Link>          
        </h1>
      </div>
    );
  }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/components/Banner.js